import { tailwindSheet, baseStyles } from '../../../_shared/styles.js';

const sheet = new CSSStyleSheet();
sheet.replaceSync(`
    :host {
        display: block;
        width: 100%;
    }
`);

export default [tailwindSheet, baseStyles, sheet];
